import styled from 'styled-components';

import { rem } from '../../utils';

export const StyledWrapper = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
`;

export const StyledGroup = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledTitleWrapper = styled.a`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${({ theme }) =>
    `${rem(theme.Spacing.Size.Small)} 0 ${rem(theme.Spacing.Size.MediumSmall)}`};

  cursor: pointer;
`;

export const StyledTileIconWrapper = styled.div<{ isOpened: boolean }>`
  transform: rotate(${({ isOpened }) => (isOpened ? '270' : '90')}deg);
`;
